import { useTranslation } from 'react-i18next';

import { Button } from '@nucleus-commerce/ui/components/button';

import { placeholderToken } from '../schemas/placeholder-rules';

export interface PlaceholderChipsProps {
  names: readonly string[];
  onInsert: (name: string) => void;
  disabled?: boolean;
}

/** One chip per placeholder the event accepts; a click inserts it where the caret was. */
export function PlaceholderChips({ names, onInsert, disabled }: PlaceholderChipsProps) {
  const { t } = useTranslation('notifications');
  return (
    <div className="flex flex-col gap-1.5">
      <p className="text-muted-foreground text-xs">{t('editor.placeholdersHint')}</p>
      <ul className="flex flex-wrap gap-1.5" aria-label={t('editor.placeholders')}>
        {names.map((name) => (
          <li key={name}>
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="h-7 px-2 font-mono text-xs"
              disabled={disabled}
              aria-label={t('editor.insert', { name })}
              // Keep the caret in the field the chip writes into.
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => onInsert(name)}
            >
              {placeholderToken(name)}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
